import { fetchAsObservable } from 'fetcher!sofe';
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, flatMap, map, pluck } from 'rxjs/operators';

export function searchContacts(inputRef) {
  return search(inputRef, executeClientSearch);
}

export function searchFiles(inputRef) {
  return search(inputRef, executeFileSearch);
}

function search(inputRef, executeSearch) {
  let input = fromEvent(inputRef.current, 'input');
  let keydown = fromEvent(inputRef.current, 'keydown');

  const values = input.pipe(
    map(e => {
      return encodeURIComponent(e.target.value.toLowerCase());
    })
  );

  return {
    arrows: keydown.pipe(
      map(e => e.keyCode),
      filter(code => code === 38 || code === 40 || code === 13 || code === 27 || code === 9)
    ),
    empty: values.pipe(
      filter(text => text.trim().length < 1),
      debounceTime(500)
    ),
    results: values.pipe(
      distinctUntilChanged(),
      filter(text => text.trim().length >= 1),
      debounceTime(500),
      flatMap(executeSearch)
    ),
  };
}

const executeClientSearch = searchString => {
  const searchTerm = searchString.trim();

  const limit = 50;

  return fetchAsObservable(`api/contacts/search?&limit=${limit}&search_string=${searchTerm}`).pipe(pluck('contacts'));
};

const executeFileSearch = searchString => {
  const searchTerm = searchString.trim();

  const limit = 20;

  return fetchAsObservable(`api/docs/search?&limit=${limit}&search_term=${searchTerm}`).pipe(pluck('files'));
};
